"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = void 0;
var components_1 = require("../components");
function main(_a) {
    var enableLegacySalvoLiteComponentSupport = _a.enableLegacySalvoLiteComponentSupport;
    if (window.isNodeJS) {
        // Loaded by the SalvoTsPlugin, return component service for metadata extraction
        return {
            isThemeInfo: true,
            componentService: components_1.componentService,
        };
    }
    if (enableLegacySalvoLiteComponentSupport) {
        components_1.componentService.enableLegacySupport();
    }
    components_1.componentService.bootstrap();
}
exports.main = main;
//# sourceMappingURL=main.js.map